import dayjs, { Dayjs } from "dayjs";
import { useEffect } from "react";

import {
  calculateDateRangePresets,
  DateRangePicker,
} from "@/Components/v2/organism/DateRangePicker";
import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { formatDate } from "@/shared/utils/formatDate";

import { useDateRangeStore } from "../store/useDateRangeStore";

type RangeValue = [Dayjs | null, Dayjs | null] | null;

const DatePickerWrapper: React.FC = () => {
  const { initInfo, loading, tree } = useInfo();
  const { startDate, endDate, minDate, maxDate, setDateRange, init } = useDateRangeStore();

  const formmattedStartDate = dayjs(startDate);
  const formmattedEndDate = dayjs(endDate);
  const formmattedMinDate = dayjs(minDate);
  const formmattedMaxDate = dayjs(maxDate);

  const handleDateRangeChange = (newRange: RangeValue) => {
    if (!newRange) return;

    const [newStartDayjs, newEndDayjs] = newRange;
    if (!newStartDayjs || !newEndDayjs) return;

    const newStart = formatDate(newStartDayjs);
    const newEnd = formatDate(newEndDayjs);
    if (newStart && newEnd) setDateRange(newStart, newEnd);
  };

  useEffect(() => {
    if (!startDate && !endDate && tree) {
      init(tree);
    }
  }, [startDate, endDate, tree, loading, initInfo, init]);

  if (!startDate || !endDate || !minDate || !maxDate) {
    return <></>;
  }

  return (
    <DateRangePicker
      value={[formmattedStartDate, formmattedEndDate]}
      onChange={handleDateRangeChange}
      presets={calculateDateRangePresets(formmattedMinDate, formmattedMaxDate) || []}
      allowClear={false}
      size="large"
      minDate={formmattedMinDate}
      maxDate={formmattedMaxDate}
      format={dayjs.localeData().longDateFormat("L")}
      name="dateRange"
    />
  );
};

export default DatePickerWrapper;
